/* ProGym Saint-Eustache — chrome-sport interactions
   All motion respects: (1) prefers-reduced-motion, (2) master toggle. */
(function () {
  'use strict';

  var html = document.documentElement;
  var KEY = 'pgse-motion';

  /* ---------- Motion master switch ---------- */
  function systemReduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function motionOn() {
    return html.getAttribute('data-pgse-motion') === 'on';
  }
  function applyMotion(state) {
    html.setAttribute('data-pgse-motion', state);
    document.querySelectorAll('.pgse-motion-toggle .txt').forEach(function (t) {
      t.textContent = state === 'on' ? 'Motion on' : 'Motion off';
    });
    document.querySelectorAll('.pgse-motion-toggle').forEach(function (b) {
      b.setAttribute('aria-pressed', state === 'on' ? 'true' : 'false');
    });
  }
  var saved = null;
  try { saved = localStorage.getItem(KEY); } catch (e) {}
  applyMotion(saved ? saved : (systemReduced() ? 'off' : 'on'));

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pgse-motion-toggle');
    if (!btn) return;
    var next = motionOn() ? 'off' : 'on';
    applyMotion(next);
    try { localStorage.setItem(KEY, next); } catch (err) {}
  });

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('.pgse-burger');
    if (!burger) return;
    var nav = document.getElementById(burger.getAttribute('aria-controls'));
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Shine sweep on entering viewport ---------- */
  var lit = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        en.target.classList.add('is-lit');
        lit.unobserve(en.target);
      }
    });
  }, { threshold: 0.35 });
  document.querySelectorAll('.pgse-shine').forEach(function (el) { lit.observe(el); });

  /* ---------- Count-up stats ---------- */
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-pgse-count')) || 0;
    var suffix = el.getAttribute('data-pgse-suffix') || '';
    var dur = 1100;
    if (!motionOn()) { el.textContent = target.toLocaleString() + suffix; return; }
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString() + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var counted = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) {
        countUp(en.target);
        counted.unobserve(en.target);
      }
    });
  }, { threshold: 0.6 });
  document.querySelectorAll('[data-pgse-count]').forEach(function (el) { counted.observe(el); });

  /* ---------- Subtle 3D tilt on cards ---------- */
  var MAX_TILT = 4; // degrees — tasteful
  document.addEventListener('pointermove', function (e) {
    if (!motionOn() || e.pointerType === 'touch') return;
    var card = e.target.closest('.pgse-card[data-pgse-tilt]');
    if (!card) return;
    var r = card.getBoundingClientRect();
    var x = (e.clientX - r.left) / r.width - 0.5;
    var y = (e.clientY - r.top) / r.height - 0.5;
    card.style.transform =
      'perspective(900px) rotateY(' + (x * MAX_TILT) + 'deg) rotateX(' + (-y * MAX_TILT) + 'deg) translateY(-3px)';
  });
  document.addEventListener('pointerout', function (e) {
    var card = e.target.closest('.pgse-card[data-pgse-tilt]');
    if (card) card.style.transform = '';
  }, true);

  /* ---------- Reading progress bar ---------- */
  var bar = document.querySelector('.pgse-progress__bar');
  if (bar) {
    var article = document.querySelector('[data-pgse-article]') || document.body;
    var ticking = false;
    function update() {
      var rect = article.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var done = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      bar.style.width = (total > 0 ? (done / total) * 100 : 100) + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }
})();
